"use client";
import { Conversation, ConversationContent, ConversationScrollButton } from "../../features/Chat/conversation";
import { Message, MessageBranch, MessageBranchContent, MessageContent, MessageResponse } from "../../features/Chat/message";
import { useChat, type Versions } from "../../context/ChatContext";
import Review from "./Review";
import Suggestions from "./Suggestions";
import { useSubMenu } from "../../SubMenuContext";
import Sources from "../../features/Chat/Sources";
import { Loader } from "../AiLoader";
import { motion } from 'framer-motion';
import { useUser } from "../../UserContext";
const messageVariants = {
    hidden: {
        opacity: 1,
        x: 10,
        y: 10,
        scale: 0.9,
    },
    visible: {
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        transition: {
            duration: 0.25,
        },
    },
};
const Messages = () => {

    const { messages, isChatReasizing } = useChat();
    const { app } = useSubMenu();
    const { user } = useUser();

    const checkStreamingMessage = (versions: Versions[]) => {

        return versions.some(v => !v.isCompleted);
    };

    return (
        <div className="relative flex h-full w-full flex-col divide-y overflow-hidden">
            <Conversation>
                <ConversationContent>
                    {
                        messages.length === 0 ? (
                            <div className="w-full h-full flex items-center justify-center flex-col text-center gap-10">
                                <div className="flex flex-col items-center justify-center">
                                    <img className="size-11 mb-10" src="https://empreender.nyc3.digitaloceanspaces.com/LP/im/e87c4031e140.gif" />

                                    <p className="text-gray-500 font-semibold mb-2">Olá, {user?.name}!</p>
                                    <p className="text-gray-900 font-semibold">Como posso ajudar com o {app}?</p>
                                </div>

                                <div>
                                    <Suggestions />
                                </div>
                            </div>
                        ) : (messages.map(({ versions, ...message }) => (
                            <MessageBranch defaultBranch={0} key={message.key}>
                                <MessageBranchContent>
                                    <>
                                        {versions.map((version) => (
                                            <motion.div key={`${message.key}-${version.id}`} className="origin-bottom-right"
                                                variants={message.from === 'user' ? messageVariants : {}}
                                                initial="hidden"
                                                animate="visible"
                                            >
                                                <Message
                                                    from={message.from}
                                                    key={`${message.key}-${version.id}`}
                                                >
                                                    <div>
                                                        <MessageContent>
                                                            <MessageResponse>{version.content}</MessageResponse>
                                                            {message.from === 'assistant' && <Sources message={message} version={version} />}
                                                        </MessageContent>
                                                    </div>
                                                </Message>
                                            </motion.div>
                                        ))}
                                    </>
                                </MessageBranchContent>
                                {message.from === 'assistant' && !checkStreamingMessage(versions) && <Review idResposta={message.id_resposta} versions={versions} />}
                            </MessageBranch>
                        )))
                    }
                    {
                        isChatReasizing && (
                            <p className="m-0">
                                <Loader />
                            </p>
                        )
                    }
                </ConversationContent>
                <ConversationScrollButton />
            </Conversation>
        </div>
    );
};

export default Messages;
